import { render, staticRenderFns } from "./ExpenseDetails.vue?vue&type=template&id=32ebf8f0&scoped=true&"
import script from "./ExpenseDetails.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDetails.vue?vue&type=style&index=0&id=32ebf8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ebf8f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ebf8f0')) {
      api.createRecord('32ebf8f0', component.options)
    } else {
      api.reload('32ebf8f0', component.options)
    }
    module.hot.accept("./ExpenseDetails.vue?vue&type=template&id=32ebf8f0&scoped=true&", function () {
      api.rerender('32ebf8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/myexpenses/ExpenseDetails.vue"
export default component.exports